export const IMAGES = {
  heroBg: "https://images.unsplash.com/photo-1755963969538-00dfa22a7c0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxzY2klMjBmaSUyMGZ1dHVyaXN0aWMlMjBjaXR5JTIwM2QlMjByZW5kZXJ8ZW58MHx8fHwxNzg5MDQzMTMyfDA&ixlib=rb-4.1.0&q=85",
  sciFiCity: "https://images.unsplash.com/photo-1728457848586-fc2c468b4689?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwyfHxzY2klMjBmaSUyMGZ1dHVyaXN0aWMlMjBjaXR5JTIwM2QlMjByZW5kZXJ8ZW58MHx8fHwxNzg5MDQzMTMyfDA&ixlib=rb-4.1.0&q=85",
  cameraGear: "https://images.unsplash.com/photo-1632670536499-ebc8bc72892a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxjaW5lbWElMjBmaWxtJTIwcHJvZHVjdGlvbiUyMHN0dWRpb3xlbnwwfHx8fDE3ODkwNDMxMzJ8MA&ixlib=rb-4.1.0&q=85",
  cameraOp: "https://images.unsplash.com/photo-1632670467450-bc8f70fe5ad1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxjaW5lbWElMjBmaWxtJTIwcHJvZHVjdGlvbiUyMHN0dWRpb3xlbnwwfHx8fDE3ODkwNDMxMzJ8MA&ixlib=rb-4.1.0&q=85",
  filmSet: "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxmaWxtJTIwc2V0JTIwZGlyZWN0b3IlMjBjYW1lcmF8ZW58MHx8fHwxNzg5MDQzMTM2fDA&ixlib=rb-4.1.0&q=85",
  clapper: "https://images.unsplash.com/photo-1515634928627-2a4e0dae3ddf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxmaWxtJTIwc2V0JTIwZGlyZWN0b3IlMjBjYW1lcmF8ZW58MHx8fHwxNzg5MDQzMTM2fDA&ixlib=rb-4.1.0&q=85",
};

export const SHOWREEL_URL = "/showreel.mp4";
export const SHOWREEL_WEBM_URL = "/showreel.webm";

export const CLIENTS = ["NETFLIX", "HBO MAX", "WARNER BROS", "A24", "MARVEL STUDIOS", "APPLE TV+", "AMAZON MGM", "LEGENDARY"];

export const SHOTS = [
  {
    id: "shot-roto-extraction",
    title: "Character Grooming & Detail - Roto Extraction",
    category: "rotoscopy",
    image: "/plates/roto-final.jpg",
    rawImage: "/plates/roto-raw.jpg",
    finalLabel: "ROTO MATTE",
    meta: { camera: "AP01 SCAN", render: "Silhouette 2025", frames: "120", passes: "6" },
  },
  {
    id: "shot-ne130-cleanup",
    title: "Fighters Cleanup - Prep",
    category: "prep",
    image: "/plates/prep-battle.jpg",
    rawImage: "/plates/prep-raw-v2.jpg",
    finalLabel: "PREP OUT",
    meta: { camera: "Battle SEQ", render: "Nuke 15", frames: "—", passes: "4" },
  },
  {
    id: "shot-camera-track",
    title: "Camera Tracking Solve & Vehicle Rotomation",
    category: "tracking",
    image: "/plates/tracking-final.jpg",
    rawImage: "/plates/tracking-still-raw.jpg",
    finalLabel: "TRACK SOLVE",
    meta: { camera: "A0031C009", render: "3DEqualizer", frames: "65", passes: "4" },
  },
  {
    id: "shot-vehicle-rotomation",
    title: "Vehicle Rotomation — CG Car Integration",
    category: "rotomation",
    image: "/plates/rotomation-final.jpg",
    rawImage: "/plates/rotomation-raw.jpg",
    finalLabel: "ROTOMATION OUT",
    meta: { camera: "Live Plate", render: "Maya 2026", frames: "—", passes: "3" },
  },
  {
    id: "shot-set-extension",
    title: "Background Extension - Comp",
    category: "compositing",
    image: "/plates/comp-final.jpg",
    rawImage: "/plates/comp-raw.jpg",
    meta: { camera: "A114C013", render: "Nuke 15", frames: "12,150", passes: "3" },
  },
];

export const PROJECTS = [
  {
    id: "proj-ballerina",
    title: "THE BALLERINA",
    client: "Independent Feature",
    year: "",
    tags: ["Psychological Horror", "Feature Film"],
    image: "/plates/ballerina-poster.jpg",
    poster: true,
    description: "The Ballerina is a critically acclaimed independent psychological horror film. KTH Studios delivered the film's rotoscopy, prep and camera tracking — invisible work that keeps the haunting grounded in reality.",
    scope: ["Rotoscopy & keying", "Paint / prep cleanup", "Camera tracking", "Invisible compositing"],
  },
  {
    id: "proj-desert-warrior",
    title: "DESERT WARRIOR",
    client: "Dir. Rupert Wyatt",
    year: "",
    tags: ["Historical Epic", "Action-Adventure"],
    image: "/plates/desert-warrior-poster.jpg",
    poster: true,
    description: "Desert Warrior is a historical action-adventure epic directed by Rupert Wyatt (Rise of the Planet of the Apes). KTH Studios delivered rotoscopy and prep across the film's large-scale action sequences.",
    scope: ["Rotoscopy", "Paint / prep cleanup", "Crowd & battle prep", "Sequence QC"],
  },
  {
    id: "proj-lik",
    title: "LOVE INSURANCE KOMPANY",
    client: "Feature Film",
    year: "",
    tags: ["Sci-Fi Romance", "Feature Film"],
    image: "/plates/lik-poster.jpg",
    poster: true,
    description: "Love Insurance Kompany (LIK) is a futuristic romantic entertainer set in a gleaming sci-fi city. KTH Studios delivered rotoscopy, prep and camera tracking across the film's futuristic world.",
    scope: ["Rotoscopy & keying", "Paint / prep cleanup", "Camera tracking"],
  },
  {
    id: "proj-kwid",
    title: "RENAULT KWID",
    client: "Renault",
    year: "",
    tags: ["Camera Tracking", "Vehicle Rotomation"],
    image: "/plates/kwid.jpg",
    description: "Renault Kwid commercial work. KTH Studios delivered camera tracking and vehicle rotomation — survey-accurate camera solves and frame-locked CG vehicle integration for the Kwid campaign.",
    scope: ["3D camera solves", "Vehicle rotomation", "CG vehicle integration", "Projection QC checks"],
  },
  {
    id: "proj-citroen",
    title: "CITROËN CAR COMMERCIALS",
    client: "Citroën",
    year: "",
    tags: ["Camera Tracking", "Rotomation", "CGI"],
    image: "/plates/rotomation-final.jpg",
    description: "A series of Citroën car commercials. KTH Studios delivered camera tracking, vehicle rotomation and CG integration — from survey-accurate camera solves to full CG car replacements locked seamlessly into live-action plates.",
    scope: ["3D camera solves", "Vehicle rotomation", "CG car integration", "Projection QC checks"],
  },
];

export const SERVICES = [
  {
    id: "rotoscopy",
    title: "Rotoscopy & Keying",
    description: "Pixel-accurate roto and matte extraction with clean, stable edges — plus academy-grade green/blue screen keying ready for final comp.",
    points: ["Roto & mattes", "Green/blue screen keying", "Edge refinement", "Silhouette extraction"],
  },
  {
    id: "prep",
    title: "Paint/Prep",
    description: "Meticulous plate preparation — cleanup, wire and rig removal, and restoration that makes every plate comp-ready.",
    points: ["Paint & cleanup", "Wire & rig removal", "Plate restoration", "Dust-busting & denoise"],
  },
  {
    id: "tracking",
    title: "Camera Tracking & Rotomation",
    description: "Rock-solid 3D camera solves, object and body tracking, matchmove and rotomation that lock CG into live-action plates.",
    points: ["3D camera solves", "Object & body tracking", "Rotomation & matchmove", "Lidar / survey integration"],
  },
  {
    id: "cgi",
    title: "3D / CGI & Creatures",
    description: "Photoreal assets, digital doubles and creature work — from sculpt and groom to muscle sim and final animation.",
    points: ["Digital doubles", "Creature pipeline", "Hard-surface & env assets"],
  },
  {
    id: "virtual",
    title: "Virtual Production",
    description: "LED volume environments in Unreal Engine 5 with on-set supervision and in-camera final workflows.",
    points: ["LED volumes", "Real-time UE5 scenes", "On-set VFX supervision"],
  },
];
